// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3PtoK","colMin":"styles_colMin__1Ft7s"};